
export class GraphhopperAddress {  
  lon : number;
  lat : number;
}

